"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes", "className", "theme", "colorScheme", "invertScheme"];
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      display: 'inline-flex',
      fontSize: '2.45rem',
      margin: '.25rem 1rem .15rem 0',
      '& $root': {
        margin: 0
      },
      '& svg': {
        verticalAlign: 'top'
      },
      // Match the 1em height/width we use when loading our own svg icons
      '& img': {
        height: '1em',
        width: '1em'
      }
    },
    colorScheme: theme.mixins.colorScheme,
    invertScheme: theme.mixins.invertScheme
  };
};
/*:: type Props = InjectSheetProvidedProps &
  HTMLSpanElement & {
    colorScheme?: string,
    invertScheme?: boolean
  };*/
var Icon = function Icon(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    theme = _ref /*:: */.theme,
    colorScheme = _ref /*:: */.colorScheme,
    invertScheme = _ref /*:: */.invertScheme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, invertScheme ? classes.invertScheme : classes.colorScheme, true), className),
    "data-color": colorScheme || undefined
  }, props));
};
Icon.defaultProps = {
  invertScheme: false
};
Icon.displayName = 'Icon';
var _default = exports.default = (0, _injectSheet.default)(Style)(Icon);
//# sourceMappingURL=Icon.js.map